import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDInput from "components/MDInput";
import LoadingButton from "components/LoadingButton";
import { Grid } from "@mui/material";
import DropdownSelect from "components/DropdownSelect";
import TranslatableTextField from "components/TranslatableTextField";
import { useLanguage } from "contexts/language.context";

export default function RegionsDialog({ isOpen, onSubmit, data, type }) {
  const { label } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [region, setRegion] = React.useState({
    description: { en: "" },
    territoryId: null,
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
    setRegion({
      description: { en: "" },
      territoryId: null,
    });
  }, [isOpen]);

  React.useEffect(() => {
    setRegion({
      ...data.region,
      description: data?.region?.allLanguageDescription || { en: "" },
    });
  }, [data.region]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          const result = await onSubmit(region);
          if (result.success) {
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {type == "edit" ? label("edit-region") : label("create-region")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 1.5 }}>
          <Grid item xs={12}>
            <TranslatableTextField
              autoFocus
              required
              id="description"
              name="description"
              label={label("name-singular")}
              type="text"
              values={region.description}
              onChange={(e) => {
                setRegion({
                  ...region,
                  description: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <DropdownSelect
              required
              label={label("territory-singular")}
              initialValue={region?.territoryId || ""}
              onChange={(newValue) => {
                setRegion({ ...region, territoryId: newValue?.id || null });
              }}
              items={
                data?.territories?.map((c) => ({ id: c.id, label: c.name })) ||
                []
              }
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {type == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
